import { effects } from 'redux-saga'

import { receiveClients } from '../../modules/client'

export default function* receiveRelatedClients(action) {
  const clients = action.payload.partners
    .reduce(
      (ret, partner) => {
        if (partner.client) {
          ret.push(partner.client)
        }

        if (partner.relationships) {
          ret = partner.relationships.reduce(
            (iret, rel) => { iret.push(rel.client); return iret },
            ret,
          )
        }

        return ret
      },
      [],
    )

  yield effects.put.resolve(receiveClients(clients))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/partner/receiveRelatedClients.js